// extracted by mini-css-extract-plugin
export default {"container":"InputRange_container__3NX31","slider":"InputRange_slider__ppc2P","disable":"InputRange_disable__TZ1u7","active":"InputRange_active__BiLXy"};